import { TablePaginationConfig } from "antd";
import { fetchPassengerWalletDetailByPassengerIdApi } from "api/passengerWallet";
import { useNotificationContext } from "contexts/NotificationContext";
import {
  defaultPassengerWalletDetail,
  IPassengerWalletDetailResponse,
} from "models/passengerWallet";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function usePassengerWalletDetail() {
  const id: string = useParams().id!;
  const { showError } = useNotificationContext();
  const [data, setData] =
    useState<IPassengerWalletDetailResponse>(defaultPassengerWalletDetail);

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [data.page, id]); // eslint-disable-line

  const fetchData = async () => {
    setData((prev) => ({ ...prev, loading: true }));
    const { data: response, error } = await fetchPassengerWalletDetailByPassengerIdApi(
      id,
      data.page,
      data.per_page
    );
    if (response) {
      if (response.data && response.data.histories) {
          response.data.histories = response.data.histories.map((value) => ({
            ...value,
            key: value.id,
          }));
      }
      setData((prev) => ({ ...prev, ...response }));
    } else showError(error!.message);
    setData((prev) => ({ ...prev, loading: false }));
  };

  const handlePageChange = ({ current }: TablePaginationConfig) => {
    if (current) setData((prev) => ({ ...prev, page: current }));
  };

  return { data, handlePageChange };
}
